import { render, staticRenderFns } from "./ProgramApprovalPage.vue?vue&type=template&id=8e2afd86"
import script from "./ProgramApprovalPage.ts?vue&type=script&lang=js&external"
export * from "./ProgramApprovalPage.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports